export class SelfSignupTokenEntity {
  constructor(public readonly token: string) {}
}
